import { TableManagement } from '../../components/Admin/Table_Management';
import AdminLayout from '../../components/Admin/Layout/AdminLayout';
import { useAuth } from '@/context/AuthContext';
import { P } from '@/config/permissionCodes';

export default function TableManagementPage() {
  const { hasPermission } = useAuth();

  if (!hasPermission(P.BACK_OFFICE.TABLES.SCREEN)) {
    return (
      <AdminLayout>
        <div className="flex items-center justify-center py-24 text-center">
          <div>
            <p className="text-lg font-semibold text-gray-700">Access Denied</p>
            <p className="text-sm text-gray-500 mt-1">You don't have permission to view table management.</p>
          </div>
        </div>
      </AdminLayout>
    );
  }

  return (
    <AdminLayout>
      <TableManagement />
    </AdminLayout>
  );
}